import { useCallback, useRef, useState } from 'react';
import { ImageCard } from '@components/catalog/my-sizes/my-sizes/steps/stepOne';

// Custom hook for managing universe selection state
export const useUniverseManagement = () => {
  const [curUniverse, setCurUniverse] = useState<ImageCard | null>(null);
  const curUniverseRef = useRef<ImageCard | null>(null);

  const setUniverse = useCallback((universe: ImageCard) => {
    setCurUniverse(universe);
    curUniverseRef.current = universe;
  }, []);

  return { curUniverse, curUniverseRef, setUniverse };
};
